import { DxContainer, DxSpacer } from '@dvag/design-system-react';

import { SettingHeader } from './component/SettingHeader/SettingHeader';
import { VPDigitalSettings } from './component/VPDigitalSettings/VPDigitalSettings';
import { MoreSettings } from './component/MoreSettings/MoreSettings';

import './style.css';

export const SettingPage = () => (
  <>
    <SettingHeader />
    <DxContainer color="transparent" type="page" data-testid="setting-page-container">
      <DxSpacer size="32v" />
      <VPDigitalSettings />
      <DxSpacer size="32v" />
      <MoreSettings />
      <DxSpacer size="32v" />
    </DxContainer>
  </>
);
